import { Promise as promisePolyfill } from 'core-js/actual/promise';
import { Symbol as symbolPolyfill } from 'core-js/actual/symbol';
import { URL as urlPolyfill } from 'core-js/actual/url';
import { WeakSet as weakSetPolyfill } from 'core-js/actual/weak-set';
import { fetch as fetchPolyfill } from 'whatwg-fetch';
import { TrueType } from './modules/enums/TrueType';
export let arrayIncludes = () => {
    if (!Array.prototype.includes) {
        Object.defineProperty(Array.prototype, 'includes', {
            value: function (valueToFind, fromIndex) {
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }
                var o = Object(this);
                var len = o.length >>> 0;
                if (len === 0) {
                    return false;
                }
                var n = fromIndex | 0;
                var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
                function sameValueZero(x, y) {
                    return x === y || (typeof x === TrueType.NUMBER && typeof y === TrueType.NUMBER && isNaN(x) && isNaN(y));
                }
                while (k < len) {
                    if (sameValueZero(o[k], valueToFind)) {
                        return true;
                    }
                    k++;
                }
                return false;
            }
        });
    }
};
export let objectKeys = () => {
    if (!Object.keys) {
        Object.keys = (function () {
            'use strict';
            var hasOwnProperty = Object.prototype.hasOwnProperty, hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'), dontEnums = [
                'toString',
                'toLocaleString',
                'valueOf',
                'hasOwnProperty',
                'isPrototypeOf',
                'propertyIsEnumerable',
                'constructor'
            ], dontEnumsLength = dontEnums.length;
            return function (obj) {
                if (typeof obj !== TrueType.FUNCTION && (typeof obj !== TrueType.OBJECT || obj === null)) {
                    throw new TypeError('Object.keys called on non-object');
                }
                var result = [], prop, i;
                for (prop in obj) {
                    if (hasOwnProperty.call(obj, prop)) {
                        result.push(prop);
                    }
                }
                if (hasDontEnumBug) {
                    for (i = 0; i < dontEnumsLength; i++) {
                        if (hasOwnProperty.call(obj, dontEnums[i])) {
                            result.push(dontEnums[i]);
                        }
                    }
                }
                return result;
            };
        }());
    }
};
export let objectAssign = () => {
    if (typeof Object?.assign != TrueType.FUNCTION) {
        Object.defineProperty(Object, 'assign', {
            value: function assign(target, varArgs) {
                'use strict';
                if (target == null) {
                    throw new TypeError('Cannot convert undefined or null to object');
                }
                let to = Object(target);
                for (let index = 1; index < arguments.length; index++) {
                    let nextSource = arguments[index];
                    if (nextSource != null) {
                        for (let nextKey in nextSource) {
                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                }
                return to;
            },
            writable: true,
            configurable: true
        });
    }
};
export let arrayForEach = () => {
    if (!Array.prototype.forEach) {
        Array.prototype.forEach = function (callback) {
            var T, k;
            if (this == null) {
                throw new TypeError('this is null or not defined');
            }
            var O = Object(this);
            var len = O.length >>> 0;
            if (typeof callback !== TrueType.FUNCTION) {
                throw new TypeError(callback + ' is not a function');
            }
            if (arguments.length > 1) {
                T = arguments[1];
            }
            k = 0;
            while (k < len) {
                var kValue;
                if (k in O) {
                    kValue = O[k];
                    callback.call(T, kValue, k, O);
                }
                k++;
            }
        };
    }
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }
};
export const arrayAt = () => {
    if (![].at) {
        Array.prototype.at = function (n) {
            n = Math.trunc(n) || 0;
            if (n < 0)
                n += this.length;
            if (n < 0 || n >= this.length)
                return undefined;
            return this[n];
        };
    }
};
export let stringRepeat = () => {
    if (!String.prototype.repeat) {
        String.prototype.repeat = function (count) {
            'use strict';
            if (this == null)
                throw new TypeError('can\'t convert ' + this + ' to object');
            var str = '' + this;
            count = +count;
            if (count != count)
                count = 0;
            if (count < 0)
                throw new RangeError('repeat count must be non-negative');
            if (count == Infinity)
                throw new RangeError('repeat count must be less than infinity');
            count = Math.floor(count);
            if (str.length == 0 || count == 0)
                return '';
            if (str.length * count >= 1 << 28)
                throw new RangeError('repeat count must not overflow maximum string size');
            var maxCount = str.length * count;
            count = Math.floor(Math.log(count) / Math.log(2));
            while (count) {
                str += str;
                count--;
            }
            str += str.substring(0, maxCount - str.length);
            return str;
        };
    }
};
export let stringEndsWith = () => {
    if (!String.prototype.endsWith) {
        String.prototype.endsWith = function (search, this_len) {
            if (this_len === undefined || this_len > this.length) {
                this_len = this.length;
            }
            return this.substring(this_len - search.length, this_len) === search;
        };
    }
};
export let stringTrim = () => {
    if (!String.prototype.trim) {
        String.prototype.trim = function () {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        };
    }
};
export const stringReplaceAll = () => {
    if (!String.prototype.replaceAll) {
        String.prototype.replaceAll = function (str, newStr) {
            if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
                return this.replace(str, newStr);
            }
            return this.replace(new RegExp(str, 'g'), newStr);
        };
    }
};
export let elementPrepend = () => {
    (function (arr) {
        arr.forEach(function (item) {
            if (item.hasOwnProperty('prepend')) {
                return;
            }
            Object.defineProperty(item, 'prepend', {
                configurable: true,
                enumerable: true,
                writable: true,
                value: function prepend() {
                    var argArr = Array.prototype.slice.call(arguments), docFrag = document.createDocumentFragment();
                    argArr.forEach(function (argItem) {
                        var isNode = argItem instanceof Node;
                        docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                    });
                    this.insertBefore(docFrag, this.firstChild);
                }
            });
        });
    })([Element.prototype, Document.prototype, DocumentFragment.prototype]);
};
export let elementAppend = () => {
    (function (arr) {
        arr.forEach(function (item) {
            if (item.hasOwnProperty('append')) {
                return;
            }
            Object.defineProperty(item, 'append', {
                configurable: true,
                enumerable: true,
                writable: true,
                value: function append() {
                    var argArr = Array.prototype.slice.call(arguments), docFrag = document.createDocumentFragment();
                    argArr.forEach(function (argItem) {
                        var isNode = argItem instanceof Node;
                        docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                    });
                    this.appendChild(docFrag);
                }
            });
        });
    })([Element.prototype, Document.prototype, DocumentFragment.prototype]);
};
export let replaceChildren = () => {
    (function () {
        if (Node.prototype['replaceChildren'] === undefined) {
            Node.prototype['replaceChildren'] = function (addNodes) {
                while (this.lastChild) {
                    this.removeChild(this.lastChild);
                }
                if (addNodes !== undefined) {
                    this.append(addNodes);
                }
            };
        }
    }());
};
export let getOwnPropertyDescriptors = () => {
    if (!Object.hasOwnProperty('getOwnPropertyDescriptors')) {
        Object.defineProperty(Object, 'getOwnPropertyDescriptors', {
            configurable: true,
            writable: true,
            value: function getOwnPropertyDescriptors(object) {
                return Reflect.ownKeys(object).reduce((descriptors, key) => {
                    return Object.defineProperty(descriptors, key, {
                        configurable: true,
                        enumerable: true,
                        writable: true,
                        value: Object.getOwnPropertyDescriptor(object, key)
                    });
                }, {});
            }
        });
    }
};
export let weakSet = () => {
    if (!window?.WeakSet) {
        window.WeakSet = weakSetPolyfill;
    }
};
export const polyfillPromise = () => {
    if (!window?.Promise) {
        window.Promise = promisePolyfill;
    }
};
export const polyfillSymbol = () => {
    if (!window?.Symbol) {
        window.Symbol = symbolPolyfill;
    }
};
export const polyfillFetch = () => {
    if (!window?.fetch) {
        window.fetch = fetchPolyfill;
    }
};
export const polyfillURL = () => {
    if (!window?.URL) {
        window.URL = urlPolyfill;
    }
};
let all = () => {
    arrayAt();
    arrayForEach();
    arrayIncludes();
    elementAppend();
    elementPrepend();
    getOwnPropertyDescriptors();
    objectAssign();
    objectKeys();
    polyfillFetch();
    polyfillPromise();
    polyfillSymbol();
    polyfillURL();
    replaceChildren();
    stringEndsWith();
    stringRepeat();
    stringReplaceAll();
    stringTrim();
    weakSet();
};
export let Polyfill = {
    arrayIncludes: arrayIncludes,
    arrayAt: arrayAt,
    objectKeys: objectKeys,
    objectAssign: objectAssign,
    arrayForEach: arrayForEach,
    stringTrim: stringTrim,
    stringRepeat: stringRepeat,
    stringReplaceAll: stringReplaceAll,
    stringEndsWith: stringEndsWith,
    elementPrepend: elementPrepend,
    elementAppend: elementAppend,
    replaceChildren: replaceChildren,
    getOwnPropertyDescriptors: getOwnPropertyDescriptors,
    weakSet: weakSet,
    polyfillPromise: polyfillPromise,
    polyfillFetch: polyfillFetch,
    polyfillURL: polyfillURL,
    all: all
};
export const initializePolyfills = () => {
    arrayAt();
    arrayForEach();
    getOwnPropertyDescriptors();
    polyfillFetch();
    polyfillPromise();
    polyfillSymbol();
    polyfillURL();
    replaceChildren();
    stringReplaceAll();
    weakSet();
};
